import { ClientOrchestrationShellSnapshot } from "@t3tools/contracts";
import * as Effect from "effect/Effect";
import * as Schema from "effect/Schema";
import { FetchHttpClient, HttpClient } from "effect/unstable/http";

import { remoteEndpointUrl, remoteHttpClientLayer } from "./remote.ts";

export function fetchShellSnapshot(input: {
  readonly httpBaseUrl: string;
  readonly bearerToken?: string;
}): Promise<ClientOrchestrationShellSnapshot> {
  return Effect.runPromise(
    Effect.gen(function* () {
      const client = HttpClient.filterStatusOk(yield* HttpClient.HttpClient);
      const response = yield* client.get(
        remoteEndpointUrl(input.httpBaseUrl, "/api/orchestration/shell"),
        {
          headers: input.bearerToken ? { authorization: `Bearer ${input.bearerToken}` } : {},
        },
      );
      return yield* response.json.pipe(
        Effect.flatMap(Schema.decodeUnknownEffect(ClientOrchestrationShellSnapshot)),
      );
    }).pipe(
      Effect.provide(remoteHttpClientLayer(globalThis.fetch)),
      Effect.provideService(FetchHttpClient.RequestInit, {
        credentials: input.bearerToken ? "omit" : "include",
        cache: "no-cache",
      }),
      Effect.timeout("15 seconds"),
    ),
  );
}
